<template>
  <div v-if="value">
    <GameSettingTitle :input="value" @handleSaveDraft="handleSaveDraft" />
    <GameSettingTab :value="view" :input="value" @handleChangeView="handleChangeView" />
    <div class="z-border-red pa-2 pt-4">
      <div class="title">Report</div>
      <v-divider class="my-3" />
      <div style="display: flex; flex-direction: row; justify-content: space-between">
        <v-flex class="mx-0" style="width: max-content; flex: 0"> </v-flex>
        <v-flex class="mx-0" style="width: max-content; flex: 0">
          <v-btn outline class="mx-0" color="primary" @click="handleExport">
            <v-icon class="mr-2">download</v-icon> {{ $t('Export') }}
          </v-btn>
        </v-flex>
      </div>
      <div class="pa-2 my-2" style="border: 1px solid #eee; border-radius: 10px">
        <v-layout wrap>
          <v-flex xs12 sm6 class="px-1">
            <div class="caption mb-2">Received Code</div>
            <v-select
              v-model="filter.recive_code"
              :items="[
                { value: true, text: 'รายงานผู้โชคดี' },
                { value: false, text: 'รายงานผู้ที่ไม่ได้รางวัล' }
              ]"
              outline
              class="default-input mr-2 mb-3"
              label="ครั้งที่"
              hide-details
              placeholder="Received Code"
              dense
              solo
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <div class="caption mb-2">Campaign Period</div>
            <v-layout wrap>
              <v-flex xs12 sm6 class="px-1">
                <DatepickerCustomDialog v-model="filter.date_from">
                  <template #default="{ computedDate }">
                    <v-text-field
                      class="default-input"
                      outline
                      name="startDate"
                      readonly
                      :value="computedDate"
                      hide-details
                      single-line
                      clearable
                      :placeholder="$t('from')"
                      @click:clear="filter.date_from = undefined"
                    ></v-text-field>
                  </template>
                </DatepickerCustomDialog>
              </v-flex>
              <v-flex xs12 sm6 class="px-1">
                <DatepickerCustomDialog v-model="filter.date_to">
                  <template #default="{ computedDate }">
                    <v-text-field
                      class="default-input"
                      outline
                      name="startDate"
                      readonly
                      :value="computedDate"
                      hide-details
                      single-line
                      clearable
                      :placeholder="$t('to')"
                      @click:clear="filter.date_to = undefined"
                    ></v-text-field>
                  </template>
                </DatepickerCustomDialog>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="text-xs-center text-sm-right mt-2">
          <v-btn outline @click="handleClearSearch">{{ $t('Clear search') }}</v-btn>
          <v-btn color="primary" @click="handleSearch">
            <v-icon class="mr-2">search</v-icon>{{ $t('Search') }}
          </v-btn>
        </div>
      </div>

      <v-data-table
        :headers="headers"
        :pagination.sync="pagination"
        :items="reports"
        class="mt-2 elevation-1"
        :loading="loading"
      >
        <template #items="props">
          <td>{{ props.item.user_id }}</td>

          <template v-if="filter.recive_code">
            <td>{{ props.item.code }}</td>
          </template>
          <td>{{ props.item.line_name }}</td>
          <td>{{ props.item.timestamp | dateFormat('DD/MM/YYYY HH:mm') }}</td>
        </template>
      </v-data-table>

      <div class="text-xs-center">
        <v-btn outline color="grey" @click="handleBack">
          {{ $t('Back') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import generaliApi from '@/api/generali'
import { handleResponse, handleApiError } from '@/api/util'
import XLSX from 'xlsx'
import moment from 'moment'
import GameSettingTab from './GameSettingTab'
import GameSettingTitle from './GameSettingTitle'
export default {
  components: {
    DatepickerCustomDialog,
    GameSettingTab,
    GameSettingTitle
  },
  props: ['value', 'view'],
  data() {
    return {
      input: null,
      filter: {
        recive_code: true,
        date_from: undefined,
        date_to: undefined
      },
      showAdvanceSearch: false,
      pageNumber: 1,
      limit: 10,
      total: 0,
      reports: [],
      pagination: {},
      loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    headers: function () {
      return [
        { value: 'user_id', text: 'Userid' },
        ...(this.filter.recive_code ? [{ value: 'code', text: 'Code' }] : []),
        { value: 'line_name', text: 'LINE Name' },
        { value: 'timestamp', text: 'Created Date' }
      ]
    }
  },

  watch: {
    pagination: {
      handler() {
        this.handleGetReport()
      },
      deep: true
    }
  },
  methods: {
    async handleSaveDraft() {
      this.$emit('handleSaveDraft')
    },
    async handleChangeView(view) {
      const vm = this
      vm.$emit('handleSubmit', { view: view })
    },
    async handleGetReport() {
      try {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        const response = await generaliApi.getReport({
          config: {
            params: {
              page_id: this.selectedBot.pageid,
              campaign_id: this.value.id,
              ...this.filter,
              ...(rowsPerPage != -1
                ? {
                    limit: rowsPerPage,
                    offset: (page - 1) * rowsPerPage
                  }
                : {}),

              sort_by: sortBy,
              order_by: descending ? 'desc' : 'asc'
            }
          }
        })

        await handleResponse(response)

        this.total = response.data.total ? response.data.total : 0
        this.reports = response.data.data ? response.data.data : []
      } catch (error) {
        handleApiError(error)
      }
    },
    handleClearSearch() {
      this.filter = {
        recive_code: true,
        date_from: undefined,
        date_to: undefined
      }
      this.handleSearch()
    },

    handleBack() {
      this.$emit('handleSubmit', { step: 4 })
    },
    async handleSearch() {
      this.loading = true
      this.pageNumber = 1
      await this.handleGetReport()
      this.loading = false
    },
    handleExport() {
      let json = []
      if (this.reports.length) {
        json = this.reports.map((report) => ({
          'user id': report.user_id,
          ...(this.filter.recive_code ? { code: report.code } : {}),
          'line name': report.line_name,
          timestamp: report.timestamp ? moment(report.timestamp).format('DD/MM/YYYY HH:mm') : ''
        }))
        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'report-table.xlsx')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/Report.vue